import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './components/Login/AuthContext';
import { PricingProvider } from './components/Payment/PricingContext';
import App from './App';
import Test from './components/Test/Test';
// import LoginWithToken from './components/Login/LoginWithToken';
// import LandingPage from './components/Main/LandingPage';
// import PricingPopup from './components/Main/PricingPopup';
// import Support from './components/Main/Support';
// import TermsAndPrivacy from './components/Main/TermsAndPrivacy';

import './styles/button.css'
import './styles/style.css'
import './styles/form.css'
import Login from './components/Login/Login';
import Signup from './components/Login/Signup';
import LoginWithToken from './components/Login/LoginWithToken';
import LandingPage from './components/Page/LandingPage';
import Legal from './components/Page/Legal';
import BlogList from './components/Blog/BlogList';
import BlogPost from './components/Blog/BlogPost';
import Contact from './components/Page/Contact';
import PricingPage from './components/Page/PricingPage';
import ApiQuickstart from './components/Page/ApiQuickstart';
import ApiWebhooks from './components/Page/ApiWebhooks';
// import PublicGenerator from './components/Tools/PublicGenerator';
import ParaphraseTool from './components/Tools/ParaphraseTool';
import ExpandTool from './components/Tools/ExpandTool';
import ShortenTool from './components/Tools/ShortenTool';
import StyleTool from './components/Tools/StyleTool';
import Toolbox from './components/Tools/Toolbox';
import CancelPayment from './components/Payment/CancelPayment';
import PurchaseConfirmation from './components/Page/PurchaseConfirmation';
import NotFound from './components/Page/NotFound';

const AppRouter = () => {

    const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);

    // Ajout d'un effet pour sauvegarder la page actuelle si non authentifié
    useEffect(() => {
        if (!isAuthenticated && window.location.pathname !== '/login' && window.location.pathname !== '/signup') {
            sessionStorage.setItem('redirectUrl', window.location.pathname);
        }
    }, [isAuthenticated]);

    return (
        <Router>
            <PricingProvider>
                <Routes>
                    <Route path="/blog" element={<BlogList />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route
                        path="/"
                        element={!isAuthenticated ? <LandingPage /> : <Navigate to="/app" />}
                    />
                    <Route
                        path="/app"
                        element={isAuthenticated ? <App /> : <Navigate to="/login" />}
                    />
                    <Route
                        path="/legal"
                        element={<Legal />}
                    />
                    <Route
                        path="/login"
                        element={isAuthenticated ? <Navigate to="/app" /> : <Login />}
                    />
                    <Route
                        path="/signup"
                        element={isAuthenticated ? <Navigate to="/app" /> : <Signup />}
                    />
                    <Route
                        path="/login_with_token"
                        element={isAuthenticated ? <Navigate to="/app" /> : <LoginWithToken />}
                    />
                    {/* <Route
                        path="/tools/generate_ebook"
                        element={<PublicGenerator />}
                    /> */}
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/api/quickstart" element={<ApiQuickstart />} />
                    <Route path="/api/webhooks" element={<ApiWebhooks />} />
                    <Route path="/cancel_payment" element={<CancelPayment />} />
                    <Route path="/purchase_confirmation" element={<PurchaseConfirmation />} />
                    <Route path="/tools" element={<Toolbox />} />
                    <Route path="/tools/paraphrase" element={<ParaphraseTool />} />
                    <Route path="/tools/expand" element={<ExpandTool />} />
                    <Route path="/tools/shorten" element={<ShortenTool />} />
                    <Route path="/tools/style" element={<StyleTool />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </PricingProvider>
        </Router>
    );
};

export default AppRouter;
